
import {
    defineComponent,
    ref,
    reactive,
    onMounted,
    computed,
} from 'vue'
import { useStore } from 'vuex'
import Swal from 'sweetalert2'
import axios from 'axios'
import { Modal,notification } from 'ant-design-vue'
import { useRouter } from 'vue-router'
import {  h } from 'vue';
import Loader from '../invoice/components/Loader.vue'
import DownloadForm from './DownloadForm.vue'
import actionChecker from './../../../../classes/action_checker'

export default defineComponent({
components: {
    Loader,
    DownloadForm,
},

setup () {
    const showUploadForm = ref(false)
    const router = useRouter()
    const form_action = ref('save')
    const store = useStore()

    const loader_title = ref('Updating')
    const loader_content = ref('Updating and Sending Notification...')
    const visible_update_modal = ref(false);
    const visible_download_modal = ref(false)

    const current_page = ref(1)
    const current_page_archive = ref(1)
    const search = ref('')

    const download_form_modal = ref<InstanceType<typeof DownloadForm>>()
    const download_submit_modal = ref(false)

    const download_form = reactive({
        org_id: '',
        vendor_id: '',
        start_date: '',
        end_date: '',
    })

    const fields = ref([
        {
            title: 'Vendor',
            dataIndex: 'vendor_name',
        },
        {
            title: 'Invoice No.',
            dataIndex: 'invoice_number',
        },
        {
            title: 'Invoice Amount',
            dataIndex: 'invoice_amount',
        },
        {
            title: 'Invoice Status',
            dataIndex: 'invoice_status',
        },
        {
            title: 'Invoice Description',
            dataIndex: 'invoice_description',
        },
        {
            title: 'Assigned End User',
            dataIndex: 'end_user_name',
        },
        {
            title: 'Business Unit',
            dataIndex: 'site_name',
        },
        {
            title: 'Action',
            dataIndex: 'action',
            slots: {customRender: 'action'},
            align: 'center'
        }
    ])

    const index = (payload = {page: 1}) => {
        payload.page = current_page.value;
        store.dispatch('AdminOrEndUserEntryInventory/index', payload)
        .then((res) => {
            if(current_page.value > res.data.last_page) {
            current_page.value = res.data.last_page
            index()
            }
        })
    }

    const indexArchive = (payload = {page: 1}) => {
    payload.page = current_page_archive.value;
    store.dispatch('AdminOrEndUserEntryInventory/archive_lists', payload)
        .then((res) => {
            if(current_page_archive.value > res.data.last_page) {
            current_page_archive.value = res.data.last_page
            indexArchive()
            }
        })
    }

    const filterRecord = (payload: any) => {
        if(payload.search != undefined) {
            search.value = payload.search;
        }
        current_page.value = payload.page;
        index(payload)
    }

    const filterRecordArchives = (payload: any) => {
        current_page_archive.value = payload.page;
        indexArchive(payload)
    }

    const createRecord = () => {
        router.push('/personnel/invoice/create/admin-entry');
    }

    const editRecord = (record: any) => {
        router.push({path: '/personnel/invoice/edit/admin-entry/'+record.id});
    }

    const deleteRecord = (record: any) => {
        visible_update_modal.value = true
        store.dispatch('AdminOrEndUserEntryInventory/destroy', record.id).then(() => {
            visible_update_modal.value = false
            index()
            indexArchive()
        }).catch((err) => {
            visible_update_modal.value = false
        });
    }

    const downloadRecord = () => {
        visible_download_modal.value = true;
    }
    
    const downloadVendorInvoice = async () => {
      
        download_submit_modal.value = true;

        const new_download_form = Object.assign({}, download_form);

        if (new_download_form.start_date && new_download_form.end_date) {
            const xhr = new XMLHttpRequest();
            const api_url = process.env.VUE_APP_REPORT_URL_DIRECT;
            let download_url =
            api_url +
            "admin_vendor_invoice_reports?" +
            "org_id=" +
            download_form.org_id +
            "&vendor_id=" +
            download_form.vendor_id +
            "&start_date=" +
            download_form.start_date +
            "&end_date=" +
            download_form.end_date;

            xhr.open('GET', download_url, true);
            xhr.onload = ()  =>{
            if (xhr.readyState == 4 && xhr.status == 200) {
                
                
                const blob = xhr.response;
                const fileName = 'VendorInvoiceEntry.xlsx';

                // Create a link element to trigger the download
                const a = document.createElement('a');
                a.href = window.URL.createObjectURL(blob);
                a.download = fileName;
                a.style.display = 'none';

                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);

                if (download_form_modal.value) {
                    download_form_modal.value.resetForm();
                }
                visible_download_modal.value = false
                return;
            }

            if (xhr.readyState === 4 && xhr.status === 422) {
                Modal.error({
                title: "Download failed",
                content: "Nothing to export.",
                });
                return;
            }

            if (xhr.readyState === 4 && xhr.status === 400) {
                Modal.error({
                title: "Download failed",
                content: "The end date must be a date after or equal to start date.",
                });
                return;
            }

            if(xhr.status === 302) {
                Modal.error({
                title: "Download failed",
                content: "Nothing to export.",
                });
                return;
            }

            if (xhr.status === 404) {
                Modal.error({
                title: "Download failed",
                content:
                    "There was an error while downloading the file. Please try again later.",
                });
                return;
            }

            if (xhr.readyState === 4 && xhr.status === 500) {
                Modal.error({
                title: "Download failed",
                content:
                    "There was an error while downloading the file. Please try again later.",
                });
                return;
            }

            if (xhr.readyState === 4 && xhr.status === 401) {
                Modal.error({
                title: "Permission Denied\n",
                content:
                    "You don't have permission to perform such operation..",
                });
                return;
            }
            };
            
            xhr.setRequestHeader("Authorization", `Bearer ${window.localStorage.getItem('PAYMENT_PORTAL_TOKEN')}`);
            xhr.responseType = 'blob';
            xhr.send(null);
        } else {
            Modal.error({
            title: "Invalid date range",
            content: "Please select both start and end date.",
            });
        }
        download_submit_modal.value = false;
    };

    onMounted(() => {
        index()
        indexArchive()
    })
    const items = computed(() => store.getters['AdminOrEndUserEntryInventory/items'])
    const archive_items = computed(() => store.getters['AdminOrEndUserEntryInventory/archive_items'])
    const loading = computed(() => store.getters['AdminOrEndUserEntryInventory/status'])
    const archive_loading = computed(() => store.getters['AdminOrEndUserEntryInventory/archive_status'])

    return {
    items,
    archive_items,
    loading,
    archive_loading,
    fields,
    form_action,
    download_form,
    showUploadForm,
    filterRecord,
    filterRecordArchives,
    createRecord,
    editRecord,
    deleteRecord,
    visible_update_modal,
    visible_download_modal,
    loader_title,
    loader_content,
    downloadRecord,
    downloadVendorInvoice,
    actionChecker,
    download_form_modal,
    download_submit_modal
    }
},
})
